

import { mapState, mapGetters, mapActions } from 'vuex';
import { buildBaseJsonLd } from '~/assets/js/seo/json-ld.js';
import { getPageTitle } from '~/assets/js/seo/title.js';
import projectsStatic from '~/static/db/projects.json';
const environment = process.env.NODE_ENV || 'production';
const envSet = require(`~/api/env.${environment}.js`)

export default {

	name: 'default',

	head() {
		const pageData = this.getJsonLdPageData();
		let _description = this.$t.bind(this)("home.description");
		const jsonLd = buildBaseJsonLd({
			...pageData,
			path: this.$route.fullPath,
			locale: this.$i18n.locale,
			globalUrl: envSet.globalUrl,
			cdnUrl: envSet.cdnUrl
		});
		return {
			htmlAttrs: {
				lang: this.$i18n.locale
			},
			link: this.getHeadLinks(),
			meta: [
				{ hid: 'og:title', property: 'og:title', content: pageData.title },
				{ hid: 'og:description', property: 'og:description', content: _description },
				{ hid: 'twitter:title', name: 'twitter:title', content: pageData.title },
				{ hid: 'twitter:description', name: 'twitter:description', content: _description }
			],
			script: [
				jsonLd
			]
		};
	},

	data(){
		return {
			lang : this.$i18n.locale,
			page : this.onRouted( this.$route, this.$route ),
		}
	},

	watch : {
	    $route(to, from) {
	    	this.page = this.onRouted(to,from);
			this.$store.commit( 'UPDATE_THUMB', 'none' );
			this.$store.commit( 'UPDATE_CURSOR', 'none' );
	    },
		// '$i18n.locale'(newLocale) {
		// 	this.$store.commit( 'UPDATE_AI_LANGUAGE', newLocale );
		// }
	},

	computed: {
		...mapGetters([
			'chatAi',
			'ui',
			'projects',
			'project_selected_slug',
			'archive',
			'archive_origin_len'
		]),
	},

	methods :{

		getCanonicalPath(path){

			let cleanPath = path.split('#')[0].split('?')[0];

			if( cleanPath === '' ){
				cleanPath = '/';
			}

			if( cleanPath.charAt(cleanPath.length - 1) !== '/' ){
				cleanPath += '/';
			}

			return cleanPath;

		},

		getLocaleBasePath(path){

			if( path === '/ja/' ){
				return '/';
			}

			if( path.indexOf('/ja/') === 0 ){
				return path.replace('/ja', '');
			}

			return path;

		},

		getLocalizedPath(path, locale){

			const basePath = this.getLocaleBasePath(path);

			if( locale === 'ja' ){
				return basePath === '/' ? '/ja/' : '/ja' + basePath;
			}

			return basePath;

		},

		getHeadLinks(){

			const canonicalPath = this.getCanonicalPath(this.$route.fullPath);
			const enPath = this.getLocalizedPath(canonicalPath, 'en');
			const jaPath = this.getLocalizedPath(canonicalPath, 'ja');

			return [
				{ hid: 'canonical', rel: 'canonical', href: envSet.globalUrl + canonicalPath },
				{ hid: 'alternate-en', rel: 'alternate', hreflang: 'en', href: envSet.globalUrl + enPath },
				{ hid: 'alternate-ja', rel: 'alternate', hreflang: 'ja', href: envSet.globalUrl + jaPath },
				{ hid: 'alternate-x-default', rel: 'alternate', hreflang: 'x-default', href: envSet.globalUrl + enPath }
			];

		},

		getCurrentProject(){

			let current = null;
			let staticCurrent = null;

			for (var i = 0; i < this.projects.length; i++) {
				if (this.projects[i].slug === this.$route.params.slug) {
					current = this.projects[i];
				}
			}

			for (var n = 0; n < projectsStatic.length; n++) {
				if (projectsStatic[n].slug === this.$route.params.slug) {
					staticCurrent = projectsStatic[n];
				}
			}

			if( current && staticCurrent ){
				return Object.assign({}, current, staticCurrent);
			}

			if( current ){
				return current;
			}

			return staticCurrent;

		},

		getJsonLdPageData(){

			const pageName = (this.$route.name || '').replace(/___(en|ja)$/, '');
			const translate = this.$t.bind(this);
			let data = {
				type: 'WebPage',
				title: getPageTitle(this.$i18n.locale),
				description: translate("home.description")
			};

			switch( pageName ){
				case 'index':
				case 'home':
					data.type = 'WebPage';
					data.title = getPageTitle(this.$i18n.locale);
					data.description = translate("home.description");
				break;
				case 'about':
					data.type = 'AboutPage';
					data.title = getPageTitle(this.$i18n.locale, 'About');
					data.description = translate("about.description");
				break;
				case 'cases':
					data.type = 'CollectionPage';
					data.title = getPageTitle(this.$i18n.locale, 'Cases');
					data.description = translate("cases.description");
					data.projects = this.projects;
				break;
				case 'archives':
					data.type = 'CollectionPage';
					data.title = getPageTitle(this.$i18n.locale, 'Archives');
					data.description = translate("archives.description");
				break;
				case 'contact':
					data.type = 'ContactPage';
					data.title = getPageTitle(this.$i18n.locale, 'Contact');
					data.description = translate("contact.description");
				break;
				case 'cases-slug':
					const currentProject = this.getCurrentProject();
					if( currentProject ){
						data.type = 'CreativeWork';
						data.title = getPageTitle(this.$i18n.locale, currentProject.title);
						data.description = currentProject.description;
						data.project = currentProject;
					} else {
						data.type = 'WebPage';
						data.title = getPageTitle(this.$i18n.locale, '404');
						data.description = 'Sorry, 404 Page not found.';
					}
				break;
				case 'ai':
					data.type = 'WebPage';
					data.title = getPageTitle(this.$i18n.locale, 'AI');
					data.description = 'I am Pachi.';
				break;
				case 'terms':
					data.type = 'WebPage';
					data.title = getPageTitle(this.$i18n.locale, 'Terms of Use');
					data.description = 'Terms of Use';
				break;
				case 'privacy-policy':
					data.type = 'WebPage';
					data.title = getPageTitle(this.$i18n.locale, 'Privacy Policy');
					data.description = 'Privacy Policy';
				break;
				case 'faq':
					data.type = 'FAQPage';
					data.title = getPageTitle(this.$i18n.locale, 'FAQ');
					data.description = 'Frequently Asked Questions';
				break;
				case '400':
					data.title = getPageTitle(this.$i18n.locale, '400');
					data.description = '400 Bad request.';
				break;
				case '403':
					data.title = getPageTitle(this.$i18n.locale, '403');
					data.description = '403 Forbidden.';
				break;
				case 'offline':
					data.title = '404 Not Found';
					data.description = 'This is offline page.';
				break;
				default:
					data.type = 'WebPage';
					data.title = getPageTitle(this.$i18n.locale, '404');
					data.description = 'Sorry, 404 Page not found.';
				break;
			}

			return data;

		},

		getType( name ){

			if( !name ){

				return 'notfound';

			} else {

				let ja     = name.replace(/___ja/g, '');
				let rename = ja.replace(/___en/g, '');

				switch( rename ){
					case 'index':
						return 'home';
					break;
					case 'home':
						return 'home';
					break;
					case 'about':
						return 'about';
					break;
					case 'cases':
						return 'cases';
					break;
					case 'archives':
						return 'archives';
					break;
					case 'contact':
						return 'contact';
					break;
					case 'cases-slug':
						return 'single';
					break;
					case '404':
						return 'notfound';
					break;
					case 'ai':
						return 'ai';
					break;
					case 'terms':
						return 'terms';
					break;
					case 'privacy-policy':
						return 'privacy-policy';
					break;
					case 'faq':
						return 'faq';
					break;
					default:
						return 'single';
					break;
				}

			}

		},

		onRouted(to,from){
			return {
				current : {
					slug : to.params.slug,
					name : this.getType(to.name)
				},
				prev :{
					slug : from.params.slug,
					name : this.getType(from.name)
				} 
			}
		},

		...mapActions(['fetchChatFaq','fetchChatSetting']),

	},

	mounted(){


		//============================
		// GET CHAT SETTING & FAQ
		//============================
		this.fetchChatFaq({
			onLoaded : () =>{
				this.$nextTick(() => {
					if( styleInview ) styleInview.onInit();
				});
			}
		});
		this.fetchChatSetting({
			onLoaded : () =>{
			}
		});


		//===
		this.$nextTick(() => {

			//
			document.documentElement.style.setProperty( '--vh', window.innerHeight/100 + 'px');

			//
			const _this = this;

			//
			window.CDN = envSet.cdnUrl;
			console.log( envSet );
			console.log( process.env.NODE_ENV );

			//
			_this.onInitTimeUpdate();

			//
			window.__WT__  = 0;
			window.__WH__  = window.innerHeight;
			window.__WW__  = window.innerWidth;
			window.__SW__  = window.screen.width > window.outerWidth ? window.screen.width : window.outerWidth;
			window.__SH__  = window.screen.height > window.outerHeight ? window.screen.height : window.outerHeight;

			//
			window.$app  = document.querySelector('#__app');
			window.$html = document.querySelector('html');
			window.$body = document.querySelector('body');
			window.$splash   = document.querySelectorAll('.js-sp');
			window.$window = document.querySelector('.Sw');


			//=============================================================================
			// ██████╗ ███████╗████████╗███████╗ ██████╗████████╗
			// ██╔══██╗██╔════╝╚══██╔══╝██╔════╝██╔════╝╚══██╔══╝
			// ██║  ██║█████╗     ██║   █████╗  ██║        ██║   
			// ██║  ██║██╔══╝     ██║   ██╔══╝  ██║        ██║   
			// ██████╔╝███████╗   ██║   ███████╗╚██████╗   ██║   
			// ╚═════╝ ╚══════╝   ╚═╝   ╚══════╝ ╚═════╝   ╚═╝   
			//=============================================================================
			window.DETECT = {

				spec : {
					str   : null,
					score : 0,
				},

				webp    : false,
				touch   : false,
				retina  : false,
				webgl   : true,
				browser : null,
				legacy  : false,
				lowspec : false,

				os : {
					win     : _this.$device.isWindows,
					mac     : _this.$device.isMacOS,
					android : _this.$device.isAndroid,
					ios     : _this.$device.isIos,
					unknown : false,
				},

				device : {
					mobile  : false,
					tablet  : false,
					ipadpro : false,
					desktop : true,
					laptop  : false,
					any     : false, // tablet or mobile
				},

				ua     : window.navigator.userAgent.toLowerCase(),
				ua_ver : window.navigator.appVersion.toLowerCase(),

				once(){

					//
					if (window.ontouchstart === null) {
						this.touch = true;
					}

					//
					if( window.devicePixelRatio > 1.5 ){
						this.retina = true;
					}

					//
					if ( window.navigator.platform.indexOf("Win") != -1 ) {
						this.os.win = true;
						$html.classList.add('is-win');
					}

					//
					this.canvas = document.createElement("canvas");

					//
					this.detectSpec();
					this.detectDevide();
					this.detectBrows();
					// this.detectWebGL();
					this.detectWebp();

				},

				getUA(str) {
					return window.navigator.userAgent.toLowerCase().indexOf(str) != -1;
				},

				detectDevide(){

					if( _this.$device.isMobile || __WW__ < 640 ){

						this.device.any = true;
						this.device.mobile = true;
						this.device.tablet = false;
						this.device.desktop = false;
						$html.classList.add('is-mobile','is-any');

					} else if( _this.$device.isTablet || __WW__ < 1024 || ( !this.getUA('ipad') && ( this.getUA('macintosh') && 'ontouchend' in document )) ){

						this.device.any = true;
						this.device.mobile = false;
						this.device.tablet = true;
						this.device.desktop = false;
						$html.classList.add('is-tablet','is-any');
						if( __WW__ > 1024 ){
							this.device.ipadpro = true;
							$html.classList.add('is-large-tablet');
						}

					} else {

						this.device.any = false;
						this.device.mobile = false;
						this.device.tablet = false;
						this.device.desktop = true;
						$html.classList.add('is-desktop');
						if( __WW__ <= 1366 ){
							this.laptop = true;
						}

					}

				},

				// detectWebGL() {
				// 	var gl = this.canvas.getContext("webgl") || this.canvas.getContext("experimental-webgl");
				// 	if( gl && gl instanceof WebGLRenderingContext) {
				// 	this.webgl = true;
				// 	} else {
				// 	this.webgl = false;
				// 	}
				// },

				detectSpec(){

					this.core = window.navigator.hardwareConcurrency ? window.navigator.hardwareConcurrency : 4;

					if( this.retina ){

						// Laptop
						this.spec.str = 'Laptop';
						this.spec.score = 7;

						// Laptop HiEnd Corei7
						if( __SW__ <= 1680 && this.core >= 8 ){
							this.spec.str  = 'Laptop HiEnd, Corei7 or higher';
							this.spec.score = 8;
						}

						if( ( ( __WW__ === __SW__ ) && __SW__ <= 1680 ) && this.core >= 6 ){
							this.spec.str  = 'Laptop MidEnd, 15 Fullscreen, Corei5 or higher';
							this.spec.score = 7;
						}

						if( ( __SW__ <= 1440 ) && this.core >= 8 ){
							this.spec.str  = 'Laptop MidEnd, 13 Fullscreen, Corei7 or higher';
							this.spec.score = 8;
						}

						// Laptop HiEnd
						if( this.core >= 10 ){
							this.spec.str  = 'Laptop HiEnd';
							this.spec.score = 8;
						}

						// Desktop Corei3
						if( __SW__ > 1680 && this.core >= 4 ){
							this.spec.str  = 'Desktop MidEnd, Corei5 or higher';
							this.spec.score = 8;
						}

						// Desktop Corei5
						if( __SW__ > 1680 && this.core >= 6 ){
							this.spec.str  = 'Desktop MidEnd, Corei5 or higher';
							this.spec.score = 9;
						}

						// Desktop Corei7
						if( __SW__ > 1680 && this.core >= 8 ){
							this.spec.str  = 'Desktop HiEnd, Corei7 or higher';
							this.spec.score = 10;
						}

					} else {

						// 1x
						this.spec.str = 'Other';
						this.spec.score = 9;

					}

					//
					if( this.device.phone ){
						this.spec.str = 'Mobile';
					} else if( this.device.tablet ){
						this.spec.str = 'Tablet';
					}

					console.table( this.spec );

					$html.dataset.score = this.spec.score;

				},

				detectBrows(){

					if (this.ua.indexOf('edge') !== -1){
						this.browser = "edge";
						this.legacy  = true;
					} else if (this.ua.indexOf("iemobile") !== -1){
						this.browser = "other";
						this.legacy  = true;
						this.lowspec = true;
					} else if (this.ua.indexOf('trident/7') !== -1){
						this.browser = "other";
						this.legacy  = true;
						this.lowspec = true;
					} else if (this.ua.indexOf("msie") !== -1 && this.ua.indexOf('opera') === -1) {
						this.browser = "msie";
						this.legacy  = true;
						this.lowspec = true;
					} else if (this.ua.indexOf('chrome')  !== -1 && this.ua.indexOf('edge') === -1){
						this.browser = "chrome";
					}else if (this.ua.indexOf('safari')  !== -1 && this.ua.indexOf('chrome') === -1){
						this.browser = "safari";
					}else if (this.ua.indexOf('opera')   !== -1){
						this.browser = "opera";
					}else if (this.ua.indexOf('firefox') !== -1){
						this.browser = "firefox";
					}else if (this.ua.indexOf(' UCBrowser/') >= 0 ){
						this.browser = "other";
					}else{
						this.browser = "other";
					}

					//
					if( !this.device.any ){
						$html.dataset.brows = this.browser;
					}

				},

				detectWebp(){
					if( this.canvas.toDataURL('image/webp').indexOf('data:image/webp') == 0 ){
						this.webp = true;
					} else {
						this.webp = false;
					}
				},

			}

			//
			// window.IS_LOW_SPEC = false;
			// window.IS_LOW_RES  = false;
			window.IS_LOW_SPEC = false;
			window.IS_SUPER_LOW_SPEC = false;


			//=====
			if( __WW__ === 0 ){ location.reload(); } else { DETECT.once(); }

			//=====
			let maxContentsPixelRatio = 2;
			let maxHiPixelRatio       = 2;
			let maxMidPixelRatio      = 2;
			window.CONTENTS_RES = Math.min( window.devicePixelRatio, maxContentsPixelRatio );
			window.HI_RES       = Math.min( window.devicePixelRatio, maxHiPixelRatio );
			window.MID_RES      = Math.min( window.devicePixelRatio, maxMidPixelRatio );
			if( DETECT.device.mobile ){

				maxContentsPixelRatio = 1.75;
				maxHiPixelRatio       = 1.75;
				maxMidPixelRatio      = 1.75;

			} else if( DETECT.device.tablet ){

				maxContentsPixelRatio = 1.5;
				maxHiPixelRatio       = 1.5;
				maxMidPixelRatio      = 1.5;

			} else {

				if( window.devicePixelRatio > 1.5 ){

					if( DETECT.spec.score >= 9 ){

						if( __WW__ >= 2560 ){
							maxContentsPixelRatio = 1.25;
							maxHiPixelRatio       = 1.25;
							maxMidPixelRatio      = 1.25;
						} else if( __WW__ >= 1920 ){
							maxContentsPixelRatio = 1.5;
							maxHiPixelRatio       = 1.5;
							maxMidPixelRatio      = 1.5;
						} else if( __WW__ > 1680 ){
							maxContentsPixelRatio = 1.5;
							maxHiPixelRatio       = 1.5;
							maxMidPixelRatio      = 1.5;
						} else {
							maxContentsPixelRatio = 1.5;
							maxHiPixelRatio       = 1.5;
							maxMidPixelRatio      = 1.5;
						}

					} else if( DETECT.spec.score === 8 ){

						maxContentsPixelRatio = 1.5;
						maxHiPixelRatio       = 1.5;
						maxMidPixelRatio      = 1.5;
						IS_LOW_SPEC = true;

					} else if( DETECT.spec.score <= 7 ){

						// maxContentsPixelRatio = 1;
						// maxHiPixelRatio       = 1;
						// maxMidPixelRatio      = 1;
						if( __WW__ >= 1440 ){
							maxContentsPixelRatio = 1;
							maxHiPixelRatio       = 1;
							maxMidPixelRatio      = 1;
						} else {
							maxContentsPixelRatio = 1.25;
							maxHiPixelRatio       = 1.25;
							maxMidPixelRatio      = 1.25;
						}
						IS_LOW_SPEC = true;

					}

					CONTENTS_RES = Math.min( window.devicePixelRatio, maxContentsPixelRatio );
					HI_RES       = Math.min( window.devicePixelRatio, maxHiPixelRatio );
					MID_RES      = Math.min( window.devicePixelRatio, maxMidPixelRatio );

				} else {

					if( DETECT.spec.score >= 9 ){
						maxContentsPixelRatio = 1;
						maxHiPixelRatio       = 1.5;
						maxMidPixelRatio      = 1.5;
					} else if( DETECT.spec.score === 8 ){
						maxContentsPixelRatio = 1;
						maxHiPixelRatio       = 1.5;
						maxMidPixelRatio      = 1.5;
					} else if( DETECT.spec.score <= 7 ){
						maxContentsPixelRatio = 1;
						maxHiPixelRatio       = 1;
						maxMidPixelRatio      = 1;
						IS_LOW_SPEC = true;
					}

					CONTENTS_RES = Math.min( window.devicePixelRatio, maxContentsPixelRatio );
					HI_RES       = Math.min( window.devicePixelRatio, maxHiPixelRatio );
					MID_RES      = Math.min( window.devicePixelRatio, maxMidPixelRatio );

				}

			}

			console.log( CONTENTS_RES, HI_RES, MID_RES );

			//=====
			if( !DETECT.device.any ){
				$window = document.querySelector('.Sw');
			} else {
				$window = document.querySelector('#__app');
			}

			//=====
			window.IS_REDUCED = false;
			const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
			if( !mediaQuery || mediaQuery.matches || getParam('motion') === 'reduced' ) {
				IS_REDUCED = true;
			}
			// IS_REDUCED = true;

			window.SPLASH_PAUSE = getParam('splash') === 'pause';
			if( SPLASH_PAUSE ) console.log('[SPLASH_PAUSE] ?splash=pause — ロゴ遷移・is-loaded まで進みません');

			//=====
			$html.classList.add('is-tr-end');

			//=====
			if( IS_LOW_SPEC ) $html.classList.add('is-low');
			if( IS_REDUCED ){
				$html.classList.add('is-reduced');
			} else {
				$html.classList.add('is-normal');				
			}

			//=====
			once();

		});


	}
}

